export const defaultFields1 = [
  'id',
  'createdat',
  'createdby',
  'updatedby',
  'isdeleted',
  'updatedat',
];
export const defaultFields2 = ['date', 'createdat', 'updatedat', 'createdAt', 'updatedAt'];
